module.exports = __webpack_public_path__ + "static/img/dmlv@2x.8088a8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/dmlv@2x.png
// module id = NW6P
// module chunks = 1